import React from 'react'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls'


export default function Vendor() {
  return (
    <Card>
    <CardHeader title={<span style={{ marginRight: '5px' }}>
                <img src={toAbsoluteUrl("/media/platforms/vendorPortal.png")} alt="" title="Vendor Portal" height="32" width="32" style={{ marginRight: '5px' }}></img>Vendor Portal - Products Sync
            </span>}>
                <CardHeaderToolbar>
                </CardHeaderToolbar>
            </CardHeader>{" "}
    <CardBody>
        <a
            type='button'
            style={{cursor:'not-allowed'}}
            className='btn btn-outline-primary my-3'
            // href="https://app.ccwholesaleclothing.com/api/product_multi_import.php"
        // onClick={}
        >
            <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step1
        </a><br/>
        <a
            type='button'
            style={{cursor:'not-allowed'}}
            className='btn btn-outline-primary disabledCursor'
            // href='https://app.ccwholesaleclothing.com/api/importProduct.php'
        // onClick={}
        >
            <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync Step2
        </a>
    </CardBody>
</Card>
  )
}
